import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import firebase from '../firebase';
import ProposeToReloadBar from './ProposeToReloadBar';

const auth = firebase.auth();

export default function AdminHeaderNav (props) {
  const { user, isOldAppVersion, } = props;
  const onClickLogOut = async () => {
    if(!window.confirm('ログアウトしますか？')) return;
    await auth.signOut();
    window.location.reload();
  };

  return (
    <header className="header-nav">
      <Navbar color="dark" dark className="justify-content-between">
        <Link to="/admin" className="d-flex align-items-center navbar-brand">
          LOGISP
          <span className="ml-2 text-white">Admin</span>
        </Link>
        <Nav navbar>
          {
            user != null && (
              <UncontrolledDropdown tag="div">
                <DropdownToggle nav caret>
                  {user.displayName}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={onClickLogOut}>
                    ログアウト
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )
          }
        </Nav>
      </Navbar>
      {
        isOldAppVersion && (
          <ProposeToReloadBar />
        )
      }
    </header>
  );
};
